import React, { useContext } from 'react';
import { StyleContext } from '@theme/AppStyles';

interface PropsT {
  size?: number;
}

const OverviewIcon = ({
  size = 24
 }: PropsT) => {
  const [style] = useContext(StyleContext);
  const color = (style.name === "dark") ? "white" : "black";
  const colorHighlight = style.palette.accentPrimary;
  return (
  <svg width={size} height={size} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={colorHighlight} d="M506.6,208.1L263.9,30.4c-4.7-3.4-11-3.4-15.7,0L5.4,208.1c-5.9,4.3-7.2,12.7-2.9,18.6s12.7,7.2,18.6,2.9
			L256,57.6l234.8,171.9c2.4,1.7,5.1,2.6,7.8,2.6c4.1,0,8.1-1.9,10.7-5.4C513.8,220.7,512.5,212.4,506.6,208.1z" />
    <path fill={colorHighlight} d="M83.1,457.6V245.8c0-7.3-6-13.3-13.3-13.3s-13.3,6-13.3,13.3v225.1c0,7.3,6,13.3,13.3,13.3h372.5
			c7.3,0,13.3-6,13.3-13.3V245.8c0-7.3-6-13.3-13.3-13.3c-7.3,0-13.3,6-13.3,13.3v211.7L83.1,457.6z" />
    <path stroke={color} strokeWidth={'10'} strokeLinecap={'round'} strokeLinejoin={'round'} strokeMiterlimit={'10'} d="M166,338.6l90,52l90-52V234.7l-90.1-52l-90,52V338.6z" />
    <circle fill={color} cx="256" cy="182.6" r="12" />
    <circle fill={color} cx="166" cy="235" r="12" />
    <circle fill={color} cx="346" cy="233.5" r="12" />
    <circle fill={color} cx="256" cy="390.6" r="12" />
    <circle fill={color} cx="346" cy="338.4" r="12" />
    <circle fill={color} cx="166" cy="338.4" r="12" />
  </svg>
  )
}
export default OverviewIcon;